export const isValidEmail = (email: string): boolean => {
  // Check for one or more characters before the @ and one or more characters before and after '.'
  const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
